<template>
  <b-container
    fluid="md"
    class="square-payment-approved"
  >
    <b-row>
      <b-col class="payment-success-header">
        <div class="title">
          <font-awesome-icon
            icon="check-circle"
            class="icon success-icon"
            size="2x"
            fixed-width
          />
          Payment Successful
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="transaction-details">
          <h3>Transaction details</h3>
          <div>
            <span class="label">Date:</span>
            <span class="value">{{ txndate | longdate }}</span>
          </div>
          <div>
            <span class="label">Transaction ID </span>
            <span class="value">{{ txnid }}</span>
          </div>
          <div>
            <span class="label">Amount:</span>
            <span class="value">{{ txnAmount | formatCurrency(currency) }}</span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="payment-details">
          <h3>Payment details</h3>
        </div>
        <div>
          <span class="label">Date</span>
          <span class="value">{{ paymentDate | longdate }}</span>
        </div>
        <div>
          <span class="label">Reference</span>
          <span class="value">{{ paymentID | uuidShort }}</span>
        </div>
        <div>
          <span class="label">Receipt No</span>
          <span class="value">{{ receiptNo }}</span>
        </div>
        <div>
          <span class="label">Amount</span>
          <span class="value">{{ paymentAmount | formatCurrency(currency) }}</span>
        </div>
        <div>
          <span class="label">Surcharge</span>
          <span class="value">{{ paymentSurcharge | formatCurrency(currency) }}</span>
        </div>
        <div>
          <span class="label">Status</span>
          <span class="value">APPROVED</span>
        </div>
      </b-col>
    </b-row>

    <b-row
      v-if="isStoredCard"
      class="mt-5"
      data-cy="user-stored-card-info"
    >
      <b-col>
        <div class="title pb-4">
          <span class="h3">
            <font-awesome-icon
              icon="check-circle"
              class="success-icon"
              size="lg"
              fixed-width
            />
          </span>
          <span class="h3 pr-4">
            Stored credit card details for future use.
          </span>
        </div>
      </b-col>
    </b-row>
    <square-response-debug-wrapper
      v-if="debug"
      :debug-data="debugData"
    />
  </b-container>
</template>

<script>
import CommonTxnFields from './common-txn-fields'
import DebugWrapper from './debug.vue'

export default {
  name: 'square-payments-success',
  components: {
    'square-response-debug-wrapper': DebugWrapper
  },
  mixins: [
    CommonTxnFields
  ],
  props: {
    debug: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    currency: function() {
      return this.$store.getters['square/currency']
    },
    paymentID: function() {
      return this.paymentResponse.payment.reference
    },
    paymentAmount: function() {
      return this.paymentResponse.payment.approved_amount
    },
    paymentSurcharge: function() {
      return this.paymentResponse.payment.surcharge || 0
    },
    paymentDate: function() {
      try {
        return new Date(this.paymentResponse.payment.resptime)
      }
      catch (_err) {
        return null
      }
    },
    isStoredCard: function() {
      return Object.prototype.hasOwnProperty.call(this.paymentResponse, 'storedcard') && Object.prototype.hasOwnProperty.call(this.processingResponse.storedcard, 'id') && this.paymentResponse.storedcard.id.trim().length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
  .square-payment-approved {
    .payment-success-header {
      .title {
        font-size: 2.2rem;
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }
      .message {
        font-size: 1rem;
        margin-bottom: 1rem;
      }
    }
    .label {
      display: inline-block;
      width: 200px;
    }
    .success-icon {
      color: green;
    }
  }
</style>
